/** Display string for invoice line-item `domains` from API (string or list). */
export function formatDeliverableDomains(value: string | string[] | null | undefined): string {
  if (value == null) return '—';
  if (Array.isArray(value)) {
    return value.length ? value.join(', ') : '—';
  }
  const t = value.trim();
  return t.length ? t : '—';
}

/** First primary domain name for `agreement_links[].agreement.primary_domains` (single "Domain" column). */
export function formatPrimaryDomain(primaryDomains: { name: string }[] | null | undefined): string {
  const name = primaryDomains?.[0]?.name?.trim();
  return name?.length ? name : '—';
}
